import { useState } from 'react';
import { Container, Card, Typography, CardContent, Fab } from '@material-ui/core';
import Header from '../../../../components/Header';
import { FETCH_ADMINS, FETCH_MANAGERS, FETCH_SUPERVISORS, FETCH_TEAMS } from '../../../../graphql/queries';
import { useQuery } from '@apollo/client';
import List from './List';
import CreateDialog from './CreateDialog';
import AddIcon from '@material-ui/icons/Add';
import { useSnackbar } from "notistack";
import EditDialog from './EditDialog';

export default function TeamPage({ history }) {

    const { enqueueSnackbar } = useSnackbar();
    const [showCreate, setShowCreate] = useState(false);
    const [dataEdit, setDataEdit] = useState();

    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(8);
  
    const { loading, error, data, networkStatus, refetch } = useQuery(FETCH_TEAMS, {
      notifyOnNetworkStatusChange: true,
      variables: {
        limit: rowsPerPage,
        page: currentPage + 1
      },
      fetchPolicy: "network-only", 
    });

    return(
        <>
            <Header onBack={() => {
                history.goBack()
            }}/>

            <Container maxWidth="sm" style={{ marginTop: 86 }}>
                <Card>
                    <CardContent>
                        <Typography variant="h5" component="h1">Equipes</Typography>
                    </CardContent>

                    <List 
                        onDelete={() => {
                            enqueueSnackbar('Equipe excluída com sucesso!');
                            refetch();
                        }}
                        onEdit={(item) => setDataEdit(item)}
                        {...{ loading, error, data, networkStatus, currentPage, setCurrentPage, rowsPerPage, setRowsPerPage }} 
                    />
                    
                </Card>
            </Container>

            <CreateDialog 
                open={showCreate} 
                handleClose={() => setShowCreate(false) } 
                onCreate={() => {
                    enqueueSnackbar('Equipe cadastrada com sucesso!');
                    refetch();
                    setShowCreate(false);
                }}
            />

            <EditDialog 
                open={dataEdit ? true : false} 
                handleClose={() => setDataEdit(null) } 
                data={dataEdit}
                onEdit={() => {
                    enqueueSnackbar('Equipe editada com sucesso!');
                    refetch();
                    setDataEdit(null);
                }}
            />
            
            <Fab color="primary" onClick={() => setShowCreate(true) } style={{ position: 'absolute', bottom: 48, right: 48 }}>
                <AddIcon />
            </Fab>
        </>
    )

}